import { render } from "./SmStamp.vue?vue&type=template&id=2aab73ec&scoped=true"
import script from "./SmStamp.vue?vue&type=script&lang=js"
export * from "./SmStamp.vue?vue&type=script&lang=js"

import "./SmStamp.vue?vue&type=style&index=0&id=2aab73ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aab73ec"]])

export default __exports__